import { vuetifyBase } from '@/plugins/vuetify-base';
import { glassDefaults } from '@/plugins/vuetify-glass';
import { naiveDark, naiveLight } from '@/plugins/vuetify-naive-colors';
import { createVuetify } from 'vuetify';

export function createLagomorphaVuetify(options?: { components?: Record<string, unknown>; forceTheme?: 'naiveLight' | 'naiveDark' }) {
    const prefersDark = typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'naiveDark' : 'naiveLight';

    return createVuetify({
        components: options?.components,
        theme: {
            defaultTheme: options?.forceTheme ?? prefersDark,
            themes: { naiveLight, naiveDark },
        },
        defaults: {
            ...vuetifyBase,
            ...glassDefaults,
        },
    });
}
